var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatchUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2822 8.03607C13.2521 11.2354 13.2346 13.0957 16.1129 14.6408L16.1132 14.6405C16.3669 14.7772 16.4961 15.0683 16.4277 15.3484C16.3592 15.6282 16.1101 15.8267 15.8219 15.8309H0.624006C0.335779 15.8267 0.0866482 15.6282 0.0181844 15.3484C-0.0502794 15.0683 0.0789193 14.7772 0.332686 14.6405L0.332465 14.6403C3.21089 13.0952 3.19341 11.2349 3.16334 8.03543C3.16014 7.69444 3.15679 7.33823 3.15679 6.96557C3.15764 5.8432 3.53136 4.75278 4.21889 3.86561C4.90663 2.97845 5.86956 2.34503 6.95642 2.06432V1.26637C6.95642 0.814057 7.19781 0.395998 7.58961 0.169619C7.98137 -0.0565396 8.46418 -0.0565396 8.85598 0.169619C9.24778 0.395947 9.48917 0.814057 9.48917 1.26637V2.06432C10.576 2.34498 11.539 2.97845 12.2267 3.86561C12.9142 4.75278 13.2879 5.84314 13.2888 6.96557C13.2888 7.33846 13.2855 7.69488 13.2822 8.03607ZM6.67063 17.0984H9.77369L9.77364 17.0984C9.8653 17.0992 9.95231 17.1399 10.0117 17.2097C10.0714 17.2795 10.0976 17.3718 10.0839 17.4625C9.97087 18.0443 9.59298 18.5401 9.06182 18.8029C8.53069 19.066 7.9072 19.066 7.37626 18.8029C6.84511 18.5401 6.467 18.0443 6.35414 17.4625C6.34022 17.3707 6.36717 17.2775 6.42813 17.2072C6.48909 17.1372 6.57787 17.0975 6.67063 17.0984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatchUp);
export default __webpack_public_path__ + "static/media/catch-up.ef07412d343fd7c028b18b0d4978e697.svg";
export { ForwardRef as ReactComponent };